var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualDl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 11.53v12.354C27 25.052 26.115 26 25.024 26H2.976C1.885 26 1 25.052 1 23.884V5.116C1 3.948 1.885 3 2.976 3h16.473",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B359",
    strokeLinejoin: "round",
    d: "M6 17.049l5.03-5.85 5.047 5.819L22 10.048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualDl);
export default __webpack_public_path__ + "static/media/VisualDL.5cbebb4c.svg";
export { ForwardRef as ReactComponent };